import AccountsTag from "common/components/ui/AccountsTag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

interface AssignedToTagProps {
  owner: number;
  size: "sm" | "md";
}

export default function AssignedToTag({ owner, size }: AssignedToTagProps) {
  const { id } = useSelectedWorkspaceContext();
  const { workspaceAccounts } = useWorkspaceAccounts(id);

  const account = workspaceAccounts?.find(({ id }) => id === owner.toString());

  if (account) {
    return (
      <AccountsTag
        accounts={[account]}
        variant="purple"
        size={size}
        isLoading={false}
        tooltipContent={null}
      >
        {account.full_name}
      </AccountsTag>
    );
  }
}
